module.exports = __webpack_public_path__ + "static/co-fes-logo-dark-a1dcf6753798a412297d88296d7a4c12.png";